/**
 * Labstep
 *
 * @module components/OrganizationPlan/Show
 * @desc Display organization billing plan
 */

import { OrganizationPlanCardAddons } from 'labstep-web/components/OrganizationPlan/Card/Addons';
import { OrganizationPlanCardNextPayment } from 'labstep-web/components/OrganizationPlan/Card/NextPayment';
import { OrganizationPlanCardPaymentMethod } from 'labstep-web/components/OrganizationPlan/Card/PaymentMethod';
import { OrganizationPlanCardPlan } from 'labstep-web/components/OrganizationPlan/Card/Plan';
import { OrganizationPlanCardWorkspaces } from 'labstep-web/components/OrganizationPlan/Card/Workspaces';
import { OrganizationPlanShowFreeTrial } from 'labstep-web/components/OrganizationPlan/Show/FreeTrial';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { OrganizationPlan } from 'labstep-web/models/organization-plan.model';
import type React from 'react';
import OrganizationPlanCardUsers from '../Card/Users';
import styles from './styles.module.scss';
import type {
  OrganizationPlanShowContainerProps,
  OrganizationPlanShowProps,
} from './types';

export const OrganizationPlanShow: React.FC<
  OrganizationPlanShowProps
> = ({ organization, organizationPlan }) => (
  <div className={styles.container} id="organization-billing-plan">
    <OrganizationPlanCardPlan
      organization={organization}
      organizationPlan={organizationPlan}
    />
    <OrganizationPlanCardAddons organization={organization} />
    <OrganizationPlanCardUsers
      organization={organization}
      organizationPlan={organizationPlan}
    />
    <OrganizationPlanCardWorkspaces organization={organization} />
    <OrganizationPlanCardNextPayment
      organization={organization}
      organizationPlan={organizationPlan}
    />
    <OrganizationPlanCardPaymentMethod
      organization={organization}
      organizationPlan={organizationPlan}
    />
  </div>
);

export const OrganizationPlanShowContainer: React.FC<
  OrganizationPlanShowContainerProps
> = ({ organization }) => (
  <ReadOnMountHOC
    type="entity"
    id={organization.id}
    entityName={OrganizationPlan.entityName}
    loading={{ cached: true, loader: 'placeholder', multiplier: 1 }}
    children={({ entity: organizationPlan }) => {
      return organization.is_trialling || !organizationPlan ? (
        <OrganizationPlanShowFreeTrial organization={organization} />
      ) : (
        <OrganizationPlanShow
          organization={organization}
          organizationPlan={organizationPlan}
        />
      );
    }}
  />
);
